var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUganda(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9246 27.5405C30.4585 24.7097 32 20.9721 32 16.8738C32 12.7756 30.4584 9.03789 27.9245 6.20714L16 5.04777L4.0755 6.20714C1.54156 9.03789 0 12.7756 0 16.8738C0 20.9721 1.5415 24.7097 4.07544 27.5405L16 28.6999L27.9246 27.5405Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07544 6.20734H27.9245C24.9948 2.9344 20.7383 0.874023 15.9999 0.874023C11.2616 0.874023 7.00506 2.9344 4.07544 6.20734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.874L16 18.2653L32 16.874C32 15.0038 31.6781 13.2089 31.0882 11.5406H0.91175C0.321938 13.2089 0 15.0038 0 16.874H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91175 22.2073H31.0884C31.6781 20.5391 32 18.7443 32 16.874H0C0 18.7443 0.321938 20.5391 0.91175 22.2073V22.2073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9246 27.5406H4.07544C7.00506 30.8136 11.2616 32.874 16 32.874C20.7384 32.874 24.9949 30.8136 27.9246 27.5406Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3389 16.8738C21.3389 19.8228 18.9487 22.2129 15.9998 22.2129C13.0508 22.2129 10.6606 19.8228 10.6606 16.8738C10.6606 13.9249 13.0508 11.5347 15.9998 11.5347C18.9487 11.5347 21.3389 13.9249 21.3389 16.8738Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.956 17.1465L16.0001 16.299C16.0001 16.299 16.4577 14.78 16.4821 14.6761C16.4999 14.6002 16.5094 14.521 16.5094 14.4396C16.5094 14.1514 16.3926 13.8905 16.2037 13.7018L16.6956 13.2099C16.3809 12.8952 15.9461 12.7005 15.4659 12.7005C14.9856 12.7005 14.5508 12.8952 14.2361 13.2099L14.728 13.7018C14.5391 13.8906 14.4224 14.1515 14.4224 14.4396C14.4224 14.545 14.4383 14.6465 14.4674 14.7425L13.7268 15.483H15.0728C15.0728 15.483 14.5163 16.3188 14.2125 17.0053C13.9087 17.6917 14.2167 18.5296 14.9188 18.8417L15.3248 19.0222L16.0001 19.6569V20.3525L15.3045 21.0482H16.6958V19.6568L17.3306 19.022H18.6436C18.6499 19.009 18.6565 18.9962 18.6625 18.9828C18.9745 18.2808 18.6582 17.4585 17.956 17.1465Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUganda);
export default __webpack_public_path__ + "static/media/uganda.549a4207.svg";
export { ForwardRef as ReactComponent };